module.exports = "https://static.zego.com/_next/static/images/Phone-f6a0c450e07399a56a98b608e967bbc0.png";